export const ENetworkEventBothWays = {
  /*
   * LOCAL EVENTS FOR CLIENT+SERVER
   */
  DISCONNECT: 'disconnect',
  RESPONSE_ERROR: 'response_error',

  /*
   * REMOTE EVENTS FOR CLIENT+SERVER
   */
  PING: 'ud_ping',
  PONG: 'ud_pong',

  /*
   * WORKSPACE
   */

  WORKSPACE_USER_INVITATION_DELETE: '/workspace/user_invitation/delete',

  TRANSPORT_CLOSE: 'transport close',
  IO_CLIENT_DISCONNECT: 'io client disconnect',
  PING_TIMEOUT: 'ping timeout',
};
